import {Component, Input} from '@angular/core';
import {CommonSvgIconsComponent} from "../../../../shared/components/common-svg-icons/common-svg-icons.component";
import {CurrencyPipe, NgForOf, NgIf} from "@angular/common";
import {DropzoneConfigInterface, DropzoneModule} from "ngx-dropzone-wrapper";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GeneralService} from "../../../../core/services/general.service";
import {EventService} from "../../../../core/services/event.service";

@Component({
  selector: 'app-add-evidence',
  standalone: true,
    imports: [
        CommonSvgIconsComponent,
        CurrencyPipe,
        DropzoneModule,
        FormsModule,
        NgForOf,
        NgIf,
        ReactiveFormsModule
    ],
  templateUrl: './add-evidence.component.html',
  styleUrl: './add-evidence.component.scss'
})
export class AddEvidenceComponent {
    @Input() confirmAction!: (data: any) => void;
    @Input() data: any;
    textDropzone = '<i class="icon-cloud-up"></i>';
    public config: DropzoneConfigInterface = {
        clickable: true,
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        parallelUploads: 1,
    };
    evidencesUploaded: string[] = [];
    public evidenceFrom: FormGroup;
    constructor(public modal: NgbModal, private fb: FormBuilder, private generalService:GeneralService, private serviceEvent:EventService){
        this.evidenceFrom= this.fb.group({
            id: [""],
            evidence: [[]],
            eventId:new FormControl("")
        });
    }

    ngOnInit(){

    }

    saveEvidence(): void {
        this.evidenceFrom.get('eventId')?.setValue(this.data.idEvent);

        if (this.evidenceFrom.valid) {
            const formData = new FormData();
            Object.keys(this.evidenceFrom.value).forEach(key => {
                formData.append(key, this.evidenceFrom.value[key]);
            });
            this.serviceEvent.add(formData).subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.generalService.showMessage('success', res.message);
                        this.cancelForm();
                    }
                },
                (err: any) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        } else {
            this.generalService.showMessage('warn', 'LLene toda la información solicitada');
        }
    }


    onUploadError(args: any): void {
        console.log('warn', args);
    }

    onUploadSuccess(event: any): void {
        const uploadedFileUrl = event[0]?.dataURL || event[0]?.dataURL || ''; // ajusta según lo que retorne tu backend

        if (uploadedFileUrl) {
            this.evidencesUploaded.push(uploadedFileUrl);
            this.evidenceFrom.patchValue({
                evidence: this.evidencesUploaded
            });
        }
    }
    onRemoveSuccess(event: any): void {
        const uploadedFileUrl = event[0]?.dataURL || ''; // asegúrate de que sea la URL que estás guardando
        if (uploadedFileUrl) {
            const index = this.evidencesUploaded.indexOf(uploadedFileUrl);
            // Si lo encuentra, lo remueve
            if (index > -1) {
                this.evidencesUploaded.splice(index, 1);
            }
            // Actualiza el form con el nuevo array
            this.evidenceFrom.patchValue({
                evidence: this.evidencesUploaded
            });
        }
    }

    //Función para cancelar nuevo registro
    cancelForm(): void {
        this.evidenceFrom.reset();
    }
}
